import React from 'react';
import { useNavigate } from 'react-router-dom';

function JoinLeague() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="card">
        <h1>Join a League</h1>
        <p>Leagues can only be joined by email invite.</p>

        <div style={{
          padding: '25px',
          backgroundColor: 'var(--surface-muted)',
          borderRadius: 'var(--radius-md)',
          border: '1px solid var(--border)',
          marginBottom: '25px',
          textAlign: 'center'
        }}>
          <h2 className="text-player-name" style={{ marginTop: 0 }}>How to join a league</h2>
          <p className="text-body" style={{ marginBottom: '20px' }}>
            Check your email for an invitation link from your league commissioner.
            Click the link to accept the invite and join the league.
          </p>
          <p className="hint">
            Don't have an invite? Ask your commissioner to send you one from the league settings page,
            or create your own league to get started.
          </p>
        </div>

        <div className="card-actions" style={{ justifyContent: 'center' }}>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/create-league')}
          >
            Create a League
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/')}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default JoinLeague;
